<template>
  <div class="new-landing">
    <div class="hero">
      <img :src="logoImg" class="hero-logo" />
      <h1>{{t("Welcome to Layoga")}}</h1>
      <h3>{{t("landing-subtitle")}}</h3>
      <h3>{{t("landing-subtitle-2")}}</h3>
    </div>

    <div class="cta">
      <button class="btn" @click="navigateToSignup">{{t("Join Now")}}</button>
    </div>

    <div class="features">
      <div class="feature" v-for="(feature, index) in [dietIcon, whatsappIcon, videoTrainingIcon]" :key="index">
        <img :src="feature" />
        <h3>{{t(`landing-feature-${index + 1}-title`)}}</h3>
        <p>{{t(`landing-feature-${index + 1}-description`)}}</p>
      </div>
    </div>

    <div class="cta">
      <button class="btn" @click="navigateToSignup">{{t("Join Now")}}</button>
    </div>

    <div class="whats-included">
      <h2>{{t("landing-included-title")}}</h2>
      <h3>{{t("landing-included-subtitle")}}</h3>
      <ul>
        <li v-for="(item, index) in 5" :key="index">
          <b>{{index + 1}}</b>
          <h3>{{t(`landing-included-${index + 1}-title`)}}</h3>
          <p>{{t(`landing-included-${index + 1}-description`)}}</p>
        </li>
      </ul>
    </div>
    <div class="cta">
      <button class="btn" @click="navigateToSignup">{{t("Join Now")}}</button>
    </div>

    <div class="about-me">
      <img :src="trainersMiran" />
      <h3>{{t("Hi, I'm Miran")}}</h3>
      <p>{{t('hi-miran-text')}}</p>

      <h3>{{t("So what do I want")}}</h3>
      <p>{{t("hi-miran-text-2")}}</p>
    </div>

    <div class="trainers">
    <h2>{{t("Meet the Trainers")}}</h2>
      <div class="trainer" v-for="(trainer, index) in [trainersKarin, trainersOfri, trainersAdi, trainersGanel]" :key="index">
        <img :src="trainer" />
        <h3>{{t(`trainer-${index + 1}-name`)}}</h3>
        <p>{{t(`trainer-${index + 1}-description`)}}</p>
        <a :href="'https://instagram.com/' + t('trainer-'+(index + 1)+'-instagram')" target="_blank">
          {{t('trainer-'+(index + 1)+'-instagram')}} <img :src="instaImg" class="instagram-link">
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import t from '@/lib/Locale'

import logoImg from '@/assets/icons/logo-primary.png';
import instaImg from '@/assets/icons/insta.png';

import trainersMiran from '@/assets/images/landing/trainers/miran.png';
import trainersAdi from '@/assets/images/landing/trainers/adi.png';
import trainersGanel from '@/assets/images/landing/trainers/ganel.png';
import trainersKarin from '@/assets/images/landing/trainers/karin.png';
import trainersOfri from '@/assets/images/landing/trainers/ofri.png';

import dietIcon from '@/assets/images/landing/diet-icon.png';
import videoTrainingIcon from '@/assets/images/landing/video-training-icon.png';
import whatsappIcon from '@/assets/images/landing/whatsapp-icon.png';
export default {
  name: 'NewLanding',
  data() {
    return {
      logoImg, instaImg,
      trainersAdi, trainersGanel, trainersKarin, trainersMiran, trainersOfri,
      dietIcon,
      videoTrainingIcon,
      whatsappIcon
    }
  },
  methods: {
    t,
    navigateToSignup() {
      this.$router.push('/quiz');
    }
  }
}
</script>